import { render, staticRenderFns } from "./course_task.vue?vue&type=template&id=1d30021a&scoped=true"
import script from "./course_task.vue?vue&type=script&lang=js"
export * from "./course_task.vue?vue&type=script&lang=js"
import style0 from "./course_task.vue?vue&type=style&index=0&id=1d30021a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d30021a",
  null
  
)

export default component.exports